import { useMediaQuery } from '@vueuse/core';

/**
 * @typedef {Object} GridApi
 * @property {ComputedRef<Number>} xs - Extra Small breakpoint
 * @property {ComputedRef<Number>} sm - Small breakpoint
 * @property {ComputedRef<Number>} md - Medium breakpoint
 * @property {ComputedRef<Number>} lg - Large breakpoint
 * @property {ComputedRef<Number>} xl - Extra Large breakpoint
 * @property {ComputedRef<Number>} xxl - Extra Extra Large breakpoint
 */

/**
 * A reactive wrapper for Bootstrap's grid system.
 *
 * @return {GridApi} The grid.
 */
export function useGridSystem () {
  // Adapted from Bootstrap grid sizing
  // https://getbootstrap.com/docs/5.0/layout/grid/#grid-options
  return {
    xs: useMediaQuery('(min-width: 0px'),
    sm: useMediaQuery('(min-width: 576px)'),
    md: useMediaQuery('(min-width: 768px)'),
    lg: useMediaQuery('(min-width: 992px)'),
    xl: useMediaQuery('(min-width: 1200px)'),
    xxl: useMediaQuery('(min-width: 1400px)')
  };
}
